export const timeoutDuration = {
  LONG_TIMEOUT: 30000,
};
